/*
 * @FilePath     : /fe-estrain-customer/src/store/modules/user/getter.js
 * @Author       : LiYang
 * @Date         : 2021-08-26 10:48:43
 * @LastEditTime : 2021-11-03 11:15:44
 * @LastEditors  : dengjianjun
 * @Description  :
 */
import { is, query } from '@didi/webx-js'
export default {
  phone(state) {
    if (state.userInfo && state.userInfo.phone) {
      try {
        return decrypt(state.userInfo.phone) || state.userInfo.phone
      } catch (error) {
        return state.userInfo.phone
      }
    }
  },

  isLogin(state) {
    return !!state.token
  },

  isAliAndNotLogin(state) {
    return (is('alipay') || is('alimp')) && !(state.token || state.userInfo?.token)
  }

}
